import React, { useState, useEffect } from 'react';
import KassaService from '../services/KassaService';
import { toast } from 'react-toastify';
import {Container, Row, Col, Card, Button, Spinner, Modal} from 'react-bootstrap';
import { Plus, Dash } from 'react-bootstrap-icons';
import KassaIncomeModal from '../components/kassa/KassaIncomeModal';
import KassaExpenseModal from '../components/kassa/KassaExpenseModal';
import { formatCurrency } from '../utils/formatters';
import {TimeClock, TimeIcon} from "@mui/x-date-pickers";
import ShowLitsenziya from "./show/ShowLitsenziya";
import KassaTarix from "./KassaTarix";

const Kassa = () => {
  const [kassas, setKassas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showIncomeModal, setShowIncomeModal] = useState(false);
  const [showExpenseModal, setShowExpenseModal] = useState(false);
  const [showTarixModal, setShowTarixModal] = useState(false);

  useEffect(() => {
    fetchKassas();
  }, []);

  const fetchKassas = async () => {
    try {
      const response = await KassaService.getKassaList();
      if (response.data) {
        // Take only first 3 kassas as per requirement
        setKassas(response.data.slice(0, 3));
      }
    } catch (error) {
      console.error('Error fetching kassas:', error);
      toast.error('Kassalarni yuklashda xatolik yuz berdi');
    } finally {
      setLoading(false);
    }
  };

  const handleModalClose = (success = false) => {
    setShowIncomeModal(false);
    setShowExpenseModal(false);
    
    if (success) {
      // Refresh kassa list after successful transaction
      fetchKassas();
    }
  };

  if (loading) {
    console.log('loading')
    return (
        <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
          <Spinner animation="border" variant="primary" />
        </Container>
    );
  }

  return (
      <Container fluid className="py-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Kassa Boshqaruvi</h2>
        <div className="d-flex gap-2">
          <Button 
            variant="success" 
            onClick={() => setShowIncomeModal(true)}
            className="d-flex align-items-center gap-1"
          >
            <Plus size={18} /> Kirim
          </Button>
          <Button 
            variant="danger" 
            onClick={() => setShowExpenseModal(true)}
            className="d-flex align-items-center gap-1"
          >
            <Dash size={18} /> Chiqim
          </Button>
          <Button
            variant="outline-info"
            onClick={() => setShowTarixModal(true)}
            className="d-flex align-items-center gap-1"
          >
            <TimeIcon size={18} /> Tarix
          </Button>
            <Modal show={showTarixModal} onHide={() => setShowTarixModal(false)} fullscreen style={{ zIndex: 2000 }}>
                <Modal.Header closeButton className="custom-modal"  style={{backgroundColor: 'lightgrey'}}>
                    <Modal.Title className='ms-3'>Kassa Tarixi</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <KassaTarix />
                </Modal.Body>
            </Modal>
        </div>
      </div>

      {loading ? (
        <div className="d-flex justify-content-center my-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <Row>
          {kassas.map((kassa) => (
            <Col key={kassa.id} md={4} className="mb-4">
              <Card>
                <Card.Body>
                  <Card.Title className="mb-3">{kassa.name}</Card.Title>
                  <div className="bg-light p-3 rounded text-center">
                    <h3 className={`mb-0 ${kassa.balance >= 0 ? 'text-success' : 'text-danger'}`}>
                      {formatCurrency(kassa.balance)}
                    </h3>
                    <small className="text-muted">Joriy balans</small>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      )}

      {/* Income Modal */}
      <KassaIncomeModal
        show={showIncomeModal}
        onHide={handleModalClose}
      />

      {/* Expense Modal */}
      <KassaExpenseModal
        show={showExpenseModal}
        onHide={handleModalClose}
      />
    </Container>
  );
};

export default Kassa;
